import React, { useEffect, useState } from 'react';
import HtmlTexteViewerModal from './HtmlTexteViewerModal';

/** Monté une fois dans index.js. Ouvre la modale sur l'event `pfm:open-html`
 *  (detail : { html, filename }). */
const GlobalHtmlViewer = () => {
  const [courant, setCourant] = useState(null);
  useEffect(() => {
    const onOpen = (e) => {
      const { html, filename } = e.detail || {};
      if (typeof html === 'string') setCourant({ html, filename: filename || 'document.html' });
    };
    window.addEventListener('pfm:open-html', onOpen);
    return () => window.removeEventListener('pfm:open-html', onOpen);
  }, []);
  if (!courant) return null;
  return <HtmlTexteViewerModal html={courant.html} filename={courant.filename} onClose={() => setCourant(null)} />;
};

export default GlobalHtmlViewer;
